var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("v-data-table", {
        staticClass: "elevation-1",
        attrs: {
          headers: _vm.headers,
          items: _vm.encounters,
          "items-per-page": -1,
          dense: "",
          "hide-default-footer": ""
        },
        scopedSlots: _vm._u(
          [
            {
              key: `item.encounterName`,
              fn: function({ item }) {
                return [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          name: "readEncounter",
                          params: { id: item.encounterId }
                        },
                        title: item.name
                      }
                    },
                    [_vm._v(" " + _vm._s(item.encounterName) + " ")]
                  )
                ]
              }
            }
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }